<template>
    <div class='leave-lists'>
        <div class="leave-lists-title" v-if="commentListTitle">
            <div class='lists-title-head'>{{ `${commentListTitle}(${commentsTotalCount})`}}</div>
        </div>
        <div class="leave-recove-main" v-if="commentsList && commentsList.length>0">
            <!-- 评论列表 -->
            <!--<div class='leave-item' :class="{'leave-item-no-padding':!commentListTitle || index == commentsList.length - 1}" v-for="(item,index) in commentsList" :key='index' :ref="item.Id" v-if="!item.IsDel || (item.ReplyList && item.ReplyList.length) || (item.IsDel&&!commentListTitle)">-->
            <div class='leave-item' :class="{'leave-item-no-padding':!commentListTitle || index == commentsList.length - 1,'comment-mark': item.Id == commentId}" v-for="(item,index) in commentsList" :key='index' :ref="item.Id" v-if="!item.IsDel || (item.ReplyList && item.ReplyList.length)">
                <div class="leave-head">
                    <img :src="item.HeadImage || '/static/images/default.png' " @error="$imgErr">
                </div>
                <div class="leave-container" :class="{itemBorder:!commentListTitle}">
                    <div class='leave-title' @click="answerPublish(item,index)">
                        <div class='title-head'>
                            <div class='title-head-name'>{{item.Name}}</div>
                            <div  class="knowledge-expert" v-if="item.Identity == 1">
                                <img src="/static/images/knowledge_expert.png" alt="">
                            </div>
                            <div class="title-head-delete" @click.stop="deleteBtnClick(item,index)" v-if="item.IsAdmin && !item.IsDel">删除</div>
                        </div>
                        <div class='title-time'>{{ $calcTime(item.CreateDate + '000') }}</div>
                    </div>
                    <div class='leave-content' >
                        <div class='leave-content-main' v-if="!item.IsDel" @click="answerPublish(item,index)">
                            <p class='content-main-word'>
                                <span class="recovery-answer" v-if='item.ReplyADAccount!=item.ReplyToADAccount'>回复</span>
                                <span class="recovery-first-name" v-if='item.ReplyADAccount!=item.ReplyToADAccount'>{{item.ReplyTo}}:</span>
                                {{item.Comment}}
                            </p>
                            <div class='content-main-img' v-if="item.AttachList && item.AttachList.length>0">
                                <div class="main-item-img" @click.stop="showImg(i,item.AttachList)" v-for="(imgs,i) in item.AttachList" :key='i'>
                                    <img class="source-img" :src="imgs || '/static/images/default.png'" @error="$imgErr">
                                </div>
                            </div>
                        </div>
                        <div class='leave-content-delete-tip' v-else>
                            <span class='left-cane'></span>
                            <span class='delete-tip'>评论已删除</span>
                            <span class='right-cane'></span>
                        </div>
                    </div>

                    <!-- 子评论 -->
                    <div class='leave-answer' @click='checkMoreRecovery(item)' v-if="!recoveryTitle&&item.ReplyList&&item.ReplyList.length">
                        <div class='leave-answer-recovery' v-if="sub < 3" v-for="(subRecovery,sub) in  item.ReplyList" :key="sub">
                            <div class="comment-content" v-if="subRecovery.ReplyToADAccount !== item.ADAccount || subRecovery.ReplyADAccount !== subRecovery.ReplyToADAccount">
                                <span>{{ subRecovery.ReplyBy }}</span> 回复 <span>{{ subRecovery.ReplyTo }}：</span>{{subRecovery.ReplyMessage}}
                            </div>
                            <div class="comment-content" v-else>
                                <span>{{ subRecovery.ReplyBy }}：</span>{{subRecovery.ReplyMessage}}
                            </div>
                            <!-- 评论中的图片 -->
                            <div class='recovery-img' v-if="subRecovery.AttachList && subRecovery.AttachList.length">
                                <div class='recovery-img-answer' v-for="(subImgs,subImgIndex) in subRecovery.AttachList" :key="subImgIndex">
                                    <img class="source-img" :src="subImgs || '/static/images/default.png'" @error="$imgErr">
                                </div>
                            </div>
                        </div>

                        <!-- <div class='more-recovery' v-if="(!item.IsDel && item.ReplyTotal>3) || (item.IsDel && item.ReplyTotal>4)">- 查看全部回复 {{item.ReplyTotal}} 条</div>       -->
                        <div class='more-recovery' v-if="item.ReplyList.length > 3">- 查看全部回复 {{item.ReplyList.length}} 条</div>
                    </div>
                </div>
            </div>
            <div class='more-leave' v-if="commentListTitle && commentsList&&commentsList.length<commentsForPageCount && commentsForPageCount>pageSize&&checkMoreComment">
                <div class='more-leave-btn' @click="$emit('checkMoreCommentClick')">查看更多评论</div>
            </div>
            <loading-more></loading-more>
        </div>
        <div class='no-leave' v-else>
            <!-- <img src='../../static/images/noLeave.png'> -->
            <img src='../../static/images/noLeave2.png'>
            <span class="no-leave-text">还没有人留言哦</span>
        </div>

        <!-- 问答输入框 -->
        <leave-question v-if="callCommentInput" :commentInfo="commentInfo" :extraInfo="extraInfo" @successPush="successPush"></leave-question>

        <!-- 评论 删除 提醒 -->
        <quit-message :mask="true" v-if='callQuitWarning' :messageTitle="messageTitle" :messageText="messageText" :queryBtn="queryBtn" @closeQuitWarning='closeQuitWarning' @eventContinue="eventContinue"></quit-message>

        <!-- 图片预览 -->
        <photo-package v-if="sourceList && sourceList.length" :list="sourceList" :options="options" selector=".source-img" @on-close="closeHandler" ref="sourcePreview">
        </photo-package>


        <!-- 水印组件 -->
        <water-mark ref="watermark2"></water-mark>
    </div>
</template>
<script>
import waterMark from '@/components/waterMark'
import nioToast from '@/components/toast'
import quitMessage from '@/components/quitMessage'
import leaveQuestion from '@/components/leaveQuestion'
import loadingMore from '@/components/loadingMore'
import {COMMENTS} from '../api'
import PhotoPackage from 'photoswipe-package'

export default {
    name: 'leaveList',
    components: {nioToast, loadingMore, leaveQuestion, quitMessage,PhotoPackage,waterMark},
    props: ['commentListTitle', 'commentsList', 'recoveryTitle', 'checkMoreComment', 'commentsTotalCount', 'commentsForPageCount', 'extraInfo'],
    data() {
        return {
            pageSize:100,

            commentIndex: '',
            deleteCommentId: '',
            deleteIndex: '',

            callQuitWarning: false,
            messageTitle: '确认删除',
            messageText: '确认删除该条评论么',
            queryBtn: '删除',

            // 图片预览组件
            sourceList:null,
            options: {
                loop: false,
                zoomEl: true,
                fullscreenEl: false,
                tapToClose: true
            },

        }
    },
    computed: {
        callCommentInput() {
            return this.$store.getters.GET_CallCommentInput
        },
        commentInfo() {
            return this.$store.getters.GET_CommentInfo
        },
        commentId(){
            return this.$route.params.commentId || ''
        }
    },
    mounted() {
        //由于图片加载比较慢，加载出来之后会把评论往下顶掉，所以  timeout 设置长一点
        setTimeout(() => {
            if(document.querySelector('.comment-mark')) document.querySelector('.comment-mark').scrollIntoViewIfNeeded(true);
        },1000)
    },
    methods: {
        //新增评论到列表中
        successPush(answerSomeInfo) {
            let replyerInfo = null;
            // 判断是否是直接评论 or是 回复主评论
            if (!this.commentInfo) {  //没有回复人，则是直接评论知识点
                // 在这里操作评论列表数组  this.commentsList
                // 初始化新评论
                replyerInfo = {
                    Name: answerSomeInfo.Name,
                    ADAccount: answerSomeInfo.ADAccount,
                    AttachList: answerSomeInfo.AttachList,
                    Comment: answerSomeInfo.Comment,
                    CreateDate: answerSomeInfo.CreateTime,
                    HeadImage: answerSomeInfo.HeadImage,
                    Id: answerSomeInfo.CommentId,
                    IsAdmin: true,
                    IsDel: false,
                    MainCommentId: answerSomeInfo.MainCommentId,
                    Identity:answerSomeInfo.Identity
                }
            } else {  //有回复人，则是回复某条评论，添加到主评论下面
                // 初始化新回复
                replyerInfo = {
                    ReplyBy: answerSomeInfo.Name,
                    ReplyTo: this.commentInfo.Name,
                    ReplyToADAccount: this.commentInfo.ADAccount,
                    ReplyADAccount: answerSomeInfo.ADAccount,
                    HeadImage: answerSomeInfo.HeadImage,
                    ReplyTime: answerSomeInfo.CreateTime,
                    ReplyMessage: answerSomeInfo.Comment,
                    AttachList: answerSomeInfo.AttachList,
                    CommentId: answerSomeInfo.CommentId,
                    MainCommentId: answerSomeInfo.MainCommentId,
                    IsAdmin: true,
                    IsDel: false,
                    Identity:answerSomeInfo.Identity
                }
            }
            // 重排数组
            this.$emit('refreshCommentList', replyerInfo, this.commentInfo, this.commentIndex)
            // 清空输入框(只需要改变vuex里面的变量就行了)
            this.$store.commit('SET_InputContent', false)
        },
        //点击删除评论按钮   打开删除确认
        deleteBtnClick(item, deleteIndex) {
            this.callQuitWarning = true
            this.deleteCommentId = item.Id
            this.deleteIndex = deleteIndex
        },
        //取消删除评论
        closeQuitWarning() {
            this.callQuitWarning = false
        },
        //确认删除评论  emit出去操作评论数组
        eventContinue() {
            let params = {
                'CommentId': this.deleteCommentId
            }
            COMMENTS.DelComment(params).then(res => {
                if (res.Code == 200) {
                    this.callQuitWarning = false
                    this.$emit('deleteComment', this.deleteIndex)
                } else {
                    this.$store.commit('SetAndCallToast', res.Msg || '删除失败，请稍后再试')
                }
            })
        },
        //查看回复更多评论
        checkMoreRecovery(data) {
            this.$router.push({
                name: 'replyList', params: {
                    commentId: data.MainCommentId,
                    uuid: this.$route.params.uuid.split('&')[0]
                }
            })
        },
        // 点击主评论回复评论发布者
        answerPublish(item, index) {
            let placeholder = '回复 ' + item.Name + ":"
            this.$store.commit('SET_CallCommentInput', true)
            this.$store.commit('SET_InputPlaceholder', placeholder)
            this.$store.commit('SET_CommentInfo', item)
            this.commentIndex = index
        },

        showImg(index,sourceList) {

            // 图片预览
            let imgList = sourceList.map((e)=>{
                return {
                    // transfer key named `FileUrl` to `src`
                    src: e,
                    FileName: e,
                    FileType: 'jpg'
                }
            })
            this.sourceList = imgList
            this.$nextTick(()=>{
                this.$refs.sourcePreview.show(index)
                this.$refs.watermark2 && this.$refs.watermark2.initWaterMark(true)
            })
        },
        closeHandler(){
            this.sourceList = [];
        }
    },
    watch:{
        '$route' (to, from) {
            if(from.name !== 'message') return
            //如果是从消息列表页过来，得更新评论
            this.$emit('initCommentList')

            //由于图片加载比较慢，加载出来之后会把评论往下顶掉，所以  timeout 设置长一点
            setTimeout(() => {
                if(document.querySelector('.comment-mark')) document.querySelector('.comment-mark').scrollIntoViewIfNeeded(true);
            },1000)
        }
    },
}
</script>
<style lang='scss' type="text/scss" scoped>
    .leave-lists {
        padding: 0 j(50);
    }

    .leave-lists-title {
        /*width:j(650);*/
        /*box-sizing: border-box;*/
        padding: j(40) 0;

        .lists-title-head {
            height: j(42);
            font-size: j(30);
            color: #363C54;
            font-weight: 700;
        }
    }

    .leave-item {
        /*width:j(650);*/
        height: 100%;
        padding-bottom: j(40);
        display: flex;
        justify-content: flex-start;

        .leave-head {
            width: j(80);
            height: 100%;

            img {
                width: j(80);
                height: j(80);
                border-radius: j(40);
                display: block;
            }
        }

        .leave-container {
            flex: 1;
            height: 100%;
            border-bottom: 1px solid #F5F5F5;
            margin-left: j(20);
            padding-bottom: j(40);

            .leave-title {
                width: j(550);
                height: j(80);

                .title-head {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    height: j(45);
                    flex-wrap: nowrap;
                    .title-head-name {
                        height: 100%;
                        font-size: j(32);
                        color: #363C54;
                        padding-right: j(20);
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        box-sizing: border-box;
                    }
                    .knowledge-expert{
                        height: 100%;
                        flex: 1;
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                        img{
                            width: j(84);
                            height: j(32);
                        }
                    }
                    .title-head-delete {
                        min-width: 28px;
                        font-size: j(24);
                        color: #9B9DA9;
                        margin-left: j(20);
                    }
                }

                .title-time {
                    width: j(550);
                    height: j(32);
                    font-size: j(24);
                    color: #9B9DA9;
                }

            }

            .leave-content {
                width: j(550);
                margin: j(18) 0 0;

                .leave-content-main {
                    width: j(550);
                    font-size: j(30);
                    color: #363C54;

                    .content-main-word {
                        width: 100%;
                        word-break: break-word;

                        .recovery-answer, .recovery-first-name {
                            width: auto;
                            height: j(40);
                            font-size: j(28);
                            color: #9B9DA9;
                        }

                        .recovery-answer {
                            color: #363C54;
                        }
                    }

                    .content-main-img {
                        width: j(550);
                        height: j(100);

                        margin: j(20) 0;
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;

                        .main-item-img {
                            width: j(100);
                            height: j(100);
                            border-radius: 4px;
                            overflow: hidden;
                            margin-right: j(20);

                            img {
                                width: 100%;
                                height: 100%;
                                display: block;
                                pointer-events: none;
                            }
                        }
                    }
                }

                .leave-content-delete-tip {
                    height: j(42);
                    font-size: j(28);
                    color: #9B9DA9;
                    position: relative;
                    .left-cane {
                        width: j(6);
                        height: j(12);

                        display: inline-block;
                        border-top: 1px solid #9B9DA9;
                        border-left: 1px solid #9B9DA9;
                        transform: scale(1.5);
                        position: absolute;
                        top: j(12);
                    }

                    .delete-tip {
                        height: j(42);
                        font-size: j(28);
                        color: #9B9DA9;
                        display: inline-block;
                        margin: 0 j(5) 0 j(10);
                    }

                    .right-cane {
                        width: j(6);
                        height: j(12);
                        display: inline-block;
                        border-right: 1px solid #9B9DA9;
                        border-bottom: 1px solid #9B9DA9;
                        transform: scale(1.5);
                        position: absolute;
                        top: j(18);
                    }
                }
            }

            .leave-answer {
                width: j(550);

                background: #F7F7F8;
                border-radius: j(4);
                padding: j(20);
                box-sizing: border-box;
                margin-top: j(18);

                .leave-answer-recovery {
                    margin-top: j(20);
                    width: 100%;
                    box-sizing: border-box;
                    &:first-child{
                        margin-top: 0;
                    }
                    .comment-content {
                        font-size: j(28);
                        color: #696D7F;
                        line-height: j(40);
                        word-wrap: break-word;
                        word-break: break-word;
                        span {
                            color: #9B9DA9;
                        }
                    }
                    .recovery-img {
                        width: j(510);
                        height: j(100);
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                        margin: j(20) 0;

                        .recovery-img-answer {
                            width: j(100);
                            height: j(100);
                            margin-right: j(20);

                            img {
                                width: j(100);
                                height: j(100);
                                display: block;
                            }
                        }

                    }
                }

                .more-recovery {
                    height: j(33);
                    margin-top: j(20);
                    font-size: j(24);
                    color: #00BCBC;
                }
            }
        }

        .itemBorder {
            border-bottom: none;
        }
    }

    .leave-item-no-padding {
        padding-bottom: 0;
    }

    .more-leave {
        width: j(650);
        height: j(60);
        margin: j(50) 0;
        // border: 1px solid red;
        display: flex;
        align-items: center;
        justify-content: center;

        .more-leave-btn {
            width: j(238);
            height: j(60);
            // border: 1px solid red;
            border-radius: j(28);
            background: #F0FCFC;
            font-size: j(28);
            color: #00BCBC;
            display: flex;
            align-items: center;
            justify-content: center;
        }

    }

    .noMoreData {
        width: 100%;
        font-size: j(28);
        color: #00BCBC;
        text-align: center;
        margin-bottom: j(50);
    }

    .no-leave {
        display: flex;
        align-items: center;
        justify-content: center;
        // margin:j(120) 0 0;
        position: relative;

        img {
            // width:j(300);
            // height:j(228);
            width: j(640);
            height: j(446);
            display: block;

        }

        .no-leave-text {
            // width:j(196);
            height: j(40);

            display: block;
            position: absolute;
            // top:j(355);
            bottom: j(70);
            font-size: j(28);
            color: #CDCED4;

        }
    }
</style>





// WEBPACK FOOTER //
// src/components/leaveList.vue